module.exports = __webpack_public_path__ + "static/img/ic8_8.94745d33.png";